import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { TableCell, IconButton, Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import { Edit, Autorenew, DeleteForever, MoreVert, SwapHoriz } from '@mui/icons-material';
import useAuth from '../../../../hooks/useAuth';
import RefreshBrokerageModal from '../../../../pages/dashboard/operator/RefreshBrokerageModal';
import DeleteBrokerModal from '../../../../pages/dashboard/operator/DeleteBrokerModal';
import ChangeAdminModal from '../../../../pages/dashboard/operator/ChangeAdminModal';

const BrokerActionTableCell = ({ row, onEditRow, onUserUpdateSuccess }) => {
  const { user } = useAuth();
  const [anchorEl, setAnchorEl] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [currentAction, setCurrentAction] = useState(null);

  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = (action, event) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    if (action === 'edit') {
      onEditRow();
      handleCloseMenu();
    } else {
      setCurrentAction(action);
      setOpenModal(true);
      handleCloseMenu();
    }
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setCurrentAction(null);
  };

  const isSuperAdmin = user?.role?.rolename === 'superAdmin';
  const rowRole = row?.role?.rolename;

  const renderMenuItems = () => {
    // SuperAdmin viewing broker list - show Change Admin and Delete Broker
    if (isSuperAdmin && rowRole === 'broker') {
      return [
        <MenuItem key="changeAdmin" onClick={(e) => handleMenuItemClick('changeAdmin', e)}>
          <ListItemIcon>
            <SwapHoriz color="primary" />
          </ListItemIcon>
          <ListItemText primary="Change Admin" />
        </MenuItem>,
        <MenuItem key="deleteBroker" onClick={(e) => handleMenuItemClick('deleteBroker', e)}>
          <ListItemIcon>
            <DeleteForever color="error" />
          </ListItemIcon>
          <ListItemText primary="Delete Broker" />
        </MenuItem>,
      ];
    }

    // SuperAdmin viewing admin list - show Edit and Refresh Brokerage
    if (isSuperAdmin && rowRole === 'admin') {
      return [
        <MenuItem key="edit" onClick={(e) => handleMenuItemClick('edit', e)}>
          <ListItemIcon>
            <Edit color="primary" />
          </ListItemIcon>
          <ListItemText primary="Edit" />
        </MenuItem>,
        <MenuItem key="refreshBrokerage" onClick={(e) => handleMenuItemClick('refreshBrokerage', e)}>
          <ListItemIcon>
            <Autorenew color="primary" />
          </ListItemIcon>
          <ListItemText primary="Refresh Brokerage" />
        </MenuItem>,
      ];
    }

    // For admin users or other cases
    return [
      <MenuItem key="edit" onClick={(e) => handleMenuItemClick('edit', e)}>
        <ListItemIcon>
          <Edit color="primary" />
        </ListItemIcon>
        <ListItemText primary="Edit" />
      </MenuItem>,
      <MenuItem key="refreshBrokerage" onClick={(e) => handleMenuItemClick('refreshBrokerage', e)}>
        <ListItemIcon>
          <Autorenew color="primary" />
        </ListItemIcon>
        <ListItemText primary="Refresh Brokerage" />
      </MenuItem>,
    ];
  };

  return (
    <>
      <TableCell align="left">
        <IconButton onClick={handleOpenMenu}>
          <MoreVert />
        </IconButton>

        <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleCloseMenu}>
          {renderMenuItems()}
        </Menu>
      </TableCell>

      <RefreshBrokerageModal
        open={openModal && currentAction === 'refreshBrokerage'}
        onClose={handleCloseModal}
        onUserUpdate={onUserUpdateSuccess}
        client={row}
      />
      <ChangeAdminModal
        open={openModal && currentAction === 'changeAdmin'}
        onClose={handleCloseModal}
        onUserUpdate={onUserUpdateSuccess}
        broker={row}
      />
      <DeleteBrokerModal
        open={openModal && currentAction === 'deleteBroker'}
        onClose={handleCloseModal}
        onUserUpdate={onUserUpdateSuccess}
        broker={row}
      />
    </>
  );
};

BrokerActionTableCell.propTypes = {
  row: PropTypes.object.isRequired,
  onEditRow: PropTypes.func.isRequired,
  onUserUpdateSuccess: PropTypes.func,
};

export default BrokerActionTableCell;
